import Controller from '@ember/controller';
import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { CENTRAL_MAPPING_HELP_CENTER_LINKS } from 'lumen/utils/central-mapping-constants';

export const CENTRAL_MAPPING_MENU_VIEWS = {
  BI: 'bi',
  BENCHMARK: 'benchmark',
} as const;

export type CentralMappingMenuView =
  (typeof CENTRAL_MAPPING_MENU_VIEWS)[keyof typeof CENTRAL_MAPPING_MENU_VIEWS];

export const isCentralMappingMenuView = (
  value: string,
): value is CentralMappingMenuView => {
  return Object.values(CENTRAL_MAPPING_MENU_VIEWS).includes(
    value as CentralMappingMenuView,
  );
};

export default class HotelSettingsCentralMappingMenuController extends Controller {
  queryParams = ['view'];

  // eslint-disable-next-line ember/no-unused-services
  @service declare access: Services['access'];

  // eslint-disable-next-line ember/no-unused-services
  @service declare centralMapping: Services['central-mapping'];

  @tracked view: CentralMappingMenuView = CENTRAL_MAPPING_MENU_VIEWS.BI;

  menuHelpCenterLink = CENTRAL_MAPPING_HELP_CENTER_LINKS.MENU_PAGE;

  get hierarchyRoute(): string {
    return 'hotel.settings.central-mapping.hierarchy';
  }

  get mappingRoute(): string {
    return 'hotel.settings.central-mapping.mapping';
  }

  @action setView(view: string): void {
    this.view = view as CentralMappingMenuView;
  }
}
